import React from "react";
import { AuthPiece } from 'aws-amplify-react';
import axios from 'axios';
import Header from './header.js';
import Footer from './footer.js';

axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

// ログイン後画面
export default class MyPageTop extends AuthPiece {
  constructor (props) {
    super(props);
    this._validAuthStates = ['signedIn'];
  }
  showComponent(theme) {
    return (
      <div className="mypageContainerBg">
        <Header authProps={this.props} />
        <Footer />
      </div>
    );
  }
}
